const validSchemaForStudents = [];

export { validSchemaForStudents };